import Filter from './filter'
import _ from 'underscore'
import Backbone from '@polleverywhere/backbone'

function parsePaginationHeaders (xhr) {
  /*
    * try to pull off pagination data
    * from headers if it's there
    */
  try {
    const pagingData = JSON.parse(xhr.getResponseHeader('X-Pagination'))

    /*
      * if the collection has an attached filter
      * model, set the paging data on it
      */
    if (this.params != null) {
      this.params(pagingData)
    }
  } catch (error) {}
}

/**
 * Collection extension to handle will_paginate results from rails
 */
export default class WillPaginateCollection extends Backbone.Collection {
  preinitialize () {
    this.on('reset', this.resetParams, this)
  }

  // Reset the pagination parameters
  resetParams () {
    this.params({}).resetSearchParams()
    this.trigger('reset:params')
  }

  /*
   * Get or set the pagination params
   *
   * @param [Object] obj The pagination params
   * @return [Filter] Filter representing the params
   * @option obj [Number] page Current page
   * @option obj [String] search Search query
   * @option obj [String] order Which attribute to order by
   * @option obj [String] direction 'ASC' or 'DESC'
   */
  params (obj) {
    if (!this._filter) { this._filter = new Filter() }

    if (obj != null) {
      return this._filter.set(obj)
    } else {
      return this._filter.attributes
    }
  }

  // Used instead of 'fetch' to include the pagination params
  query (opts) {
    if (opts == null) { opts = {} }
    opts.data = this.params()

    return this.fetch(opts)
  }

  /*
   * Determine if the collection has more to load
   *
   * @return [Boolean]
   */
  hasMore () {
    return !!this.params().next_page
  }

  /*
   * Loads another "page" of results
   *
   * This returns a promise resolved with the newly fetched models, along
   * with firing add/change events for each individual model affected
   *
   * @return [Promise]
   */
  loadMore () {
    const idAttribute = this.model.prototype.idAttribute || 'id'

    this.params({ page: this.params().next_page })
    return this.query({ remove: false }).then(newModels => {
      const newKeys = _.pluck(newModels, idAttribute)
      return this.filter(r => _.contains(newKeys, r.get(idAttribute)))
    })
  }

  /**
   * @param {Object} options
   * @param {Boolean} options.all Recursively load all results (Default: false)
   */
  fetch (options = {}) {
    _.defaults(options, {
      all: false
    })

    const request = super.fetch(options)
    request
      .then(() => {
        parsePaginationHeaders.call(this, request)
      })
      .then(() => {
        // Recursively load data until all pages are fetched
        if (options.all && this.hasMore()) {
          this.params({ page: this.params().next_page })

          // Keep appending. Don't remove
          this.query(_.extend({}, { remove: false }, options))
        }
      })

    return request
  }
}
